// @flow
import { textOnlySearch, TextOnlySearchEditor } from '../../../common/TextOnlySearch';

import type { BbCollectedApplication } from '../../../../api/type.app';
import type { SearchDefinition } from '../../../element/Search';

export const applicationSearchDef: SearchDefinition<BbCollectedApplication> = textOnlySearch<BbCollectedApplication>('application');

export const ApplicationSearch = TextOnlySearchEditor;